<template lang="pug">
  .tabs-nav
    .tabs-nav__container
      .tabs-nav__item(v-for="navItem in items")
        router-link.tabs-nav__link(
          :to="navItem.link"
          :class="$route.name === navItem.link.name && 'tabs-nav__link_active'"
          :replace="navItem.replace"
        ) {{ navItem.name }}
</template>

<script>
export default {
  name: 'TabsNav',
  props: {
    items: Array,
  },
};
</script>

<style lang="scss" scoped>
  .tabs-nav {

    &__container {
      display: flex;
      align-items: center;
    }

    &__item {
      flex: 0 0 auto;
    }

    &__link {
      display: block;
      color: inherit;
      font-weight: $font-weight-semibold;
      text-decoration: none;
      position: relative;
      padding: 20px 16px;

      &_active {
        color: $color-primary;
      }

      &::before {
        content: "";
        display: block;
        width: 100%;
        height: 3px;
        background-image: $gradient-horizontal-primary;
        position: absolute;
        left: 0;
        bottom: 0;
        opacity: 0;
        transition: $transition-default;
      }

      &_active::before {
        opacity: 1;
      }
    }
  }
</style>
